module.exports = __webpack_public_path__ + "img/candle_thumb.82493c2f.jpg";